import { useState } from 'react'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import {
  previewCommitmentLetter,
  type CommitmentLetterInputs,
  type CommitmentLetterVendor,
} from '@/api/commitmentLetters'
import { LetterPreview } from './LetterPreview'
import { vendorLabel } from './utils'

interface StepReviewProps {
  planId: string
  versionId: string
  lineItemIds: string[]
  vendors: CommitmentLetterVendor[]
  inputs: CommitmentLetterInputs
}

export function StepReview({
  planId,
  versionId,
  lineItemIds,
  vendors,
  inputs,
}: StepReviewProps) {
  const [vendorKey, setVendorKey] = useState(vendors[0]?.vendor_key ?? '')

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-3">
      <div className="flex items-center gap-3">
        <Label className="shrink-0">Vendor</Label>
        <Select value={vendorKey} onValueChange={setVendorKey}>
          <SelectTrigger className="h-9 w-[360px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {vendors.map(v => (
              <SelectItem key={v.vendor_key} value={v.vendor_key}>
                {vendorLabel(v)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <span className="text-xs text-muted-foreground">
          The ZIP includes the letter, commitment units and transit calendar for
          each of the {vendors.length} vendor(s).
        </span>
      </div>

      <LetterPreview
        queryKey={[
          'commitment-letter-preview',
          versionId,
          lineItemIds,
          vendorKey,
          inputs,
        ]}
        queryFn={() =>
          previewCommitmentLetter(planId, versionId, {
            ...inputs,
            line_item_ids: lineItemIds,
            vendor_key: vendorKey,
          })
        }
        enabled={!!vendorKey}
      />
    </div>
  )
}
